<template>
  <div class="lxm-more">
    <transition name="lxm-transition-fade" mode="out-in">
      <template v-if="loading">
        <animation :canvasStyle="{ width: '2.85rem', height: '2.85rem' }"></animation>
      </template>
      <template v-else-if="!pureLoading">
        <div class="lxm-more__button" @click="clicked">加载更多</div>
      </template>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-more
    text-align: center
  .lxm-more__button
    padding: spacing
    font-size: size-smaller
</style>

<script>
  import Animation from '../../Animation/index.vue'
  export default {
    components: {
      Animation
    },
    props: {
      loading: {
        default: true,
        type: Boolean
      },
      pureLoading: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      clicked () {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmMore.vue?3a2f80bc